import React, { Component } from "react";
import $ from "jquery";
import * as Common from "../CommonControlls/CommonJs";
import MainLayout from "../CommonControlls/MainLayout";
import Topmenu from "../CommonControlls/Topmenubar";
import { connect } from "react-redux";
import Table from "../CommonControlls/TableRendrer";
import { Link } from "react-router-dom";
import AlertModal from "../CommonControlls/AlertModal";
import { SyncConfig } from "../OfflineDb/ConfigDataSync";
import DropDown from "../CommonControlls/DropdownRendrer";
import jsPDF from "jspdf";
import DatePicker from "react-datepicker";

const mapStateToProps = (store) => {
	return store;
};

const mapDispatchToProps = (dispatch) => {
	return {
		ShowAlert: (Settings) => {
			dispatch({ type: "UpdateAlert", payload: Settings });
		},
		ShowLoader: (Isloading) => {
			dispatch({ type: "UpdateLoader", payload: Isloading });
		},
	};
};

class HCF_List extends Component {
	constructor(props) {
		super(props);
		this.state = {
			// Table
			data: [],
			page: 1,
			sizePerPage: 15,
			TotalRecord: 0,
			loading: false,
			exportLoading: false,
			ExportLoading: false,

			sortField: "id",
			idsortOrder: "desc",
			provinceNamesortOrder: "",
			districtNamesortOrder: "",
			tehsilNamesortOrder: "",
			typeIdsortOrder: "",
			namesortOrder: "",

			isMicroscope: null,
			permissions: [],

			// startDate: '01/01/2018',
			// endDate: '01/01/2030',

			startDate: new Date(),
			endDate: new Date(),

			alertModalData: {
				title: "",
				message: "",
				First_Callback: () => { },
				Second_Callback: () => { },
				type: 1,
			},

			SrList: [],
			FilteredSrs: [],
			SrId: [],

			loadingExport: false,

			ProvinceLoader: false,
			Provincelist: [],
			ProvinceId: [],

			DistrictLoader: false,
			Districtlist: [],
			FilteredDistrictlist: [],
			DistrictId: [],

			TehsilLoader: false,
			Tehsillist: [],
			FilteredTehsillist: [],
			TehsilId: [],

			HCFTypelist: [
				{ id: "1-a", name: "BHU" },
				{ id: "1-b", name: "GP" },
				{ id: "2-a", name: "RHC" },
				{ id: "2-b", name: "PPM" },
			],
			HCFTypeId: 0,
			hcfId: "",
			isActive: null,
		};
	}

	HandleDateChange = (Field, date) => {
		this.setState(
			{ [Field]: date === "" || date == null ? new Date() : date },
			() => {
				if (
					Field === "startDate" &&
					this.state.startDate > this.state.endDate
				) {
					this.setState({ endDate: this.state.startDate });
				}
			}
		);
	};

	HandleAutoSuggestValChange = (fieldId, value) => {
		this.setState(
			{
				[fieldId]: value,
				// isSaveSearch: this.state.isSearchChanged ? true : false
			},
			() => {
				if (fieldId === "ProvinceId") {
					this.FilterDistricts(value);
				}
				if (fieldId === "SrId") {
					const tempDistricts = this.state.Districtlist;
					const tempSrs = this.state.SrId + "";
					var selectedSrs = Common.ConvertToCommaSplitArray(value, "id");
					var filteredSelectedDistricts = tempDistricts.filter(
						(obj) => selectedSrs.indexOf(obj.subrecipientid) > -1
					);
					this.setState({
						FilteredDistrictlist: filteredSelectedDistricts,
					});
				}
				if (fieldId === "DistrictId") {
					this.FilterTehsils(value);
				}
				if (fieldId === "HCFTypeId") {
					const category =
						String(value).charAt(2) === "b" ? "private" : "public";
					this.setState({ category });
				}
			}
		);
	};
	FilterDistricts = (value) => {
		// filter ditrict list
		var TempArr = this.state.Districtlist;
		var selectedProvince = Common.ConvertToCommaSplitArray(value, "id");
		var filteredDistrictList = TempArr.filter(function (obj) {
			return selectedProvince.indexOf(obj.provinceId) > -1;
		});

		// filter district selected values
		var selectedDistricts = this.state.DistrictId;
		var filteredDistrictIdArr = Common.ConvertToCommaSplitArray(
			filteredDistrictList,
			"id"
		);
		var filteredSelectedDistricts = selectedDistricts.filter(function (obj) {
			return filteredDistrictIdArr.indexOf(obj.id) > -1;
		});

		const tempSrs = this.state.SrList;
		const filteredSrs = tempSrs.filter(
			(item) => selectedProvince.indexOf(item.provinceid) > -1
		);

		this.setState({
			FilteredDistrictlist: filteredDistrictList,
			// DistrictId: filteredSelectedDistricts,
			FilteredSrs: filteredSrs,
		});
	};

	FilterTehsils = (value) => {
		// filter Tehsil list
		var TempArr = this.state.Tehsillist || [];
		var selectedVale = Common.ConvertToCommaSplitArray(value, "id");
		var filteredTehsilList = TempArr.filter(function (obj) {
			return selectedVale.indexOf(obj.districtId) > -1;
		});

		// const TempSr = this.state.SrList
		// const filtered = TempSr.filter((el) => {
		//     return selectedVale.indexOf(el.districtId) > -1
		// })

		// filter Tehsil selected values
		var selectedTehsils = this.state.TehsilId;
		var filteredTehsilIdArr = Common.ConvertToCommaSplitArray(
			filteredTehsilList,
			"id"
		);
		var filteredSelectedTehsils = selectedTehsils.filter(function (obj) {
			return filteredTehsilIdArr.indexOf(obj.id) > -1;
		});

		this.setState({
			FilteredTehsillist: filteredTehsilList,
			TehsilId: filteredSelectedTehsils,
			// FilteredSrs: filtered
		});
	};

	generateCSVFileName = () => {
		const startDate = this.state.startDate;
		const endDate = this.state.endDate;

		if (!startDate || !endDate) {
			return 'HCF.csv';
		}

		const formatDate = (date) => {
			if (date instanceof Date) {
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				return `${year}-${month}-${day}`; // YYYY-MM-DD format
			}
			return date;
		};

		const startDateStr = formatDate(startDate);
		const endDateStr = formatDate(endDate);

		return `${startDateStr}_to_${endDateStr}_HCF.csv`;
	};

	render() {
		const CellMenu = (cell, row) => {
			return (
				<div>
					{this.state.permissions.includes("hcfs-update") && (
						<Link to={"/BHUAndRHC_Edit/" + row.id}>
							<button
								data-toggle="tooltip"
								title="Edit"
								class="btn TableRow_btn"
							>
								<i
									class="fa fa-pencil-square-o text-primary"
									aria-hidden="true"
								></i>
							</button>
						</Link>
					)}
					{this.state.permissions.includes("hcfs-delete") && (
						<button
							onClick={() => this.onDelete(row.id)}
							data-toggle="tooltip"
							title="Delete"
							class="btn TableRow_btn"
						>
							<i class="fa fa-trash-o text-danger" aria-hidden="true"></i>
						</button>
					)}
				</div>
			);
		};

		const columns = [
			{
				dataField: "id",
				text: "RFH ID",
				headerStyle: () => {
					return { width: "80px", fontSize: "13px" };
				},
				sort: true,
			},
			{
				dataField: "dhis2code",
				text: "DHIS2 ID",
				headerStyle: () => {
					return { width: "120px", fontSize: "13px" };
				},
				csvFormatter: (dhis2code) => (dhis2code == null ? "" : dhis2code),
			},
			{
				dataField: "miscode",
				text: "MIS ID",
				headerStyle: () => {
					return { width: "120px", fontSize: "13px" };
				},
				csvFormatter: (miscode) => (miscode == null ? "" : miscode),
			},
			{
				dataField: "provinceName",
				text: "Province",
				headerStyle: () => {
					return { width: "110px", fontSize: "13px" };
				},
				sort: true,
			},
			{
				dataField: "subRecipient_ShortName",
				text: "Sr. Name",
				headerStyle: () => {
					return { width: "110px", fontSize: "13px" };
				},
				sort: true,
			},
			{
				dataField: "districtName",
				text: "District",
				headerStyle: () => {
					return { width: "100px", fontSize: "13px" };
				},
				sort: true,
			},
			{
				dataField: "tehsilName",
				text: "Tehsil",
				headerStyle: () => {
					return { width: "100px", fontSize: "13px" };
				},
				sort: true,
			},
			{
				dataField: "name",
				text: "Name",
				headerStyle: () => {
					return { width: "95px", fontSize: "13px" };
				},
				sort: true,
			},
			{
				dataField: "category",
				text: "Category",
				headerStyle: () => {
					return { width: "90px", fontSize: "13px" };
				},
			},
			{
				dataField: "typeId",
				text: "Type",
				headerStyle: () => {
					return { width: "80px", fontSize: "13px" };
				},
				sort: true,
				formatter: (cell, row) => {
					return (
						<span>
							{cell == 1
								? row.category === "public"
									? "BHU"
									: "GP"
								: cell == 2
									? row.category === "public"
										? "RHC"
										: "PPM"
									: ""}
						</span>
					);
				},
				csvFormatter: (typeId, row) =>
					typeId == 1
						? row.category === "public"
							? "BHU"
							: "GP"
						: typeId == 2
							? row.category === "public"
								? "RHC"
								: "PPM"
							: "",
			},
			{
				dataField: "is_microscope",
				text: "Microscope",
				headerStyle: () => {
					return { width: "100px", fontSize: "13px" };
				},
			},

			{
				dataField: "samplesCountHCF",
				text: "Samples Count",
				headerStyle: () => {
					return { width: "100px", fontSize: "13px" };
				},
			},
			{
				dataField: "contact",
				text: "Contact",
				headerStyle: () => {
					return { width: "80px", fontSize: "13px" };
				},
				csvFormatter: (contact) => (contact == null ? "" : contact),
				// sort: true,
			},
			{
				dataField: "latitude",
				text: "Latitude",
				headerStyle: () => {
					return { width: "80px", fontSize: "13px" };
				},
				csvFormatter: (latitude) => (latitude == null ? "" : latitude),
				// sort: true,
			},
			{
				dataField: "longitude",
				text: "Longitude",
				headerStyle: () => {
					return { width: "80px", fontSize: "13px" };
				},
				csvFormatter: (longitude) => (longitude == null ? "" : longitude),
				// sort: true,
			},
			{
				dataField: "address",
				text: "Address",
				headerStyle: () => {
					return { width: "80px", fontSize: "13px" };
				},
				csvFormatter: (contact) => (contact == null ? "" : contact),
				// sort: true,
			},
			{
				dataField: "isActive",
				text: "Active/Inactive",
				headerStyle: () => {
					return { width: "100px", fontSize: "13px" };
				},
				formatter: (cell, row) => {
					return <p>{cell ? "Active" : "Inactive"}</p>;
				},
			},
			{
				dataField: "",
				text: "Actions",
				headerStyle: (colum, colIndex) => {
					return { width: "100px", fontSize: "13px" };
				},
				formatter: (cell, row) => {
					return CellMenu(cell, row);
				},
				csvExport: false,
			},
		];

		return (
			<div>
				<AlertModal {...this.state.alertModalData} />
				<MainLayout />
				<div id="right-panel" class="right-panel">
					<Topmenu
						PageTitle="Health Care Facilities (includes both BHUs & RHCs)"
						isShowAddBtn={this.state.permissions.includes("hcfs-add")}
						AddBtnLabel="Add BHU & RHC"
						AddBtnLink="/BHUAndRHC_Add"
					/>
					<div class="content">
						<div
							className="card"
							style={{
								marginBottom: "20px",
								background: "none",
								boxShadow: "none",
							}}
						>
							<div className="card-body row" style={{ padding: "0px" }}>
								<div className="widget-tabs-list">

									<ul className="Cases-nav nav nav-tabs">

										{this.state.permissions.includes("hcfs-view") && (
											<li>
												<Link
													to="/BHUAndRHC"
													class="active show"
												>
													HCF List
												</Link>
											</li>
										)}
										{this.state.permissions.includes("hcfs-Profile-View") && (
											<li>
												<Link to="/HCFProfiles">
													HCF Profiles
												</Link>
											</li>
										)}
									</ul>
								</div>
							</div>
						</div>
						{/* <div class="PageHeader_Container">
                            <h2 class="Pageheading">HCF</h2>
                            <div class="PageMenu_Container"><Link to="BHUAndRHC_Add"><button type="submit" id="Form_SaveBtn" class="btn btn_style2">Add HCF</button></Link></div>
                        </div> */}



						<div class="card">
							<div class="card-body">
								<div class="Table_Search row">
									<div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<label htmlFor="">Province</label>
										<DropDown
											multi={true}
											dropdownRenderer={true}
											create={false}
											onChange={this.HandleAutoSuggestValChange}
											Type="ProvinceId"
											options={this.state.Provincelist}
											val={this.state.ProvinceId}
											addPlaceholder=""
											disabled={false}
											loading={this.state.ProvinceLoader}
											searchBy="name"
											labelField="name"
											valueField="id"
											contentRenderer={true}
											placeholder="Select"
										/>
									</div>

									<div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<label htmlFor="">District</label>
										<DropDown
											multi={true}
											dropdownRenderer={true}
											create={false}
											onChange={this.HandleAutoSuggestValChange}
											Type="DistrictId"
											options={this.state.FilteredDistrictlist}
											val={this.state.DistrictId}
											addPlaceholder=""
											disabled={false}
											loading={this.state.DistrictLoader}
											searchBy="name"
											labelField="name"
											valueField="id"
											contentRenderer={true}
											placeholder="Select"
										/>
									</div>

									<div class="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<label htmlFor="">Tehsil</label>
										<DropDown
											multi={true}
											dropdownRenderer={true}
											create={false}
											onChange={this.HandleAutoSuggestValChange}
											Type="TehsilId"
											options={this.state.FilteredTehsillist}
											val={this.state.TehsilId}
											addPlaceholder=""
											disabled={false}
											loading={this.state.TehsilLoader}
											searchBy="name"
											labelField="name"
											valueField="id"
											contentRenderer={true}
											placeholder="Select"
										/>
									</div>

									<div class="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<label htmlFor="">Type</label>
										<DropDown
											multi={false}
											dropdownRenderer={false}
											create={false}
											onChange={this.HandleAutoSuggestValChange}
											Type="HCFTypeId"
											options={this.state.HCFTypelist}
											val={this.state.HCFTypeId}
											addPlaceholder=""
											disabled={false}
											loading={false}
											searchBy="name"
											labelField="name"
											valueField="id"
											contentRenderer={false}
											placeholder="Select"
										/>
									</div>

									<div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<label htmlFor="">Status</label>
										<select
											className="form-control"
											value={this.state.isActive === null ? "" : this.state.isActive ? "true" : "false"}
											onChange={(event) => {
												const value = event.target.value;
												this.setState({
													isActive: value === "" ? null : value === "true",
												});
											}}
										>
											<option value="">All</option>
											<option value="true">Active</option>
											<option value="false">Inactive</option>
										</select>
									</div>

									<div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<label htmlFor="">HCF ID</label>
										<input
											autocomplete="off"
											type="text"
											class="form-control Search_InputField"
											id="SearchHcfId"
											placeholder="Enter HCF ID"
											value={this.state.hcfId}
											onChange={(e) => this.setState({ hcfId: e.target.value })}
										/>
									</div>

									<div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<label htmlFor="">Name</label>
										<input
											autocomplete="off"
											type="text"
											class="form-control Search_InputField"
											id="SearchName"
											placeholder="Enter Name"
										/>
									</div>

									{/* <div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<label htmlFor="">
											<span style={{ color: "red" }}>* </span>Category
										</label>
										<select
											className="form-control"
											onChange={(event) =>
												this.setState({
													category: event.target.value,
												})
											}
										>
											<option value="">All</option>
											<option value="public">Public</option>
											<option value="private">Private</option>
										</select>
									</div> */}

									<div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<label htmlFor="">From</label>
										<DatePicker
											selected={this.state.startDate}
											onChange={(date) => {
												this.HandleDateChange("startDate", date);
											}}
											peekNextMonth
											showMonthDropdown
											showYearDropdown
											dropdownMode="select"
										/>
									</div>

									<div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<label htmlFor="">To</label>
										<DatePicker
											selected={this.state.endDate}
											onChange={(date) => {
												this.HandleDateChange("endDate", date);
											}}
											peekNextMonth
											showMonthDropdown
											showYearDropdown
											dropdownMode="select"
											minDate={this.state.startDate}
										/>
									</div>

									<div
										className="col-md-2"
										style={{ marginTop: "40px", marginLeft: "20px" }}
									>
										<label className="CheckBox_container Roles_CheckBox">
											<span>Microscope</span>
											<input
												onChange={(event) =>
													this.setState({ isMicroscope: event.target.checked })
												}
												type="checkbox"
											/>
											<span className="CheckBox_checkmark"></span>
										</label>
									</div>

									{this.state.permissions.includes("hcfs-add") && (
										<div class="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
											<label htmlFor=""> Import HCF file </label>
											<input
												type="file"
												id="importHcfBtn"
												name="filename"
												accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
												onChange={this.importHCF_file}
											/>
										</div>
									)}

									<div
										class="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12"
										style={{ marginTop: "30px", marginLeft: "10px" }}
									>
										<button
											onClick={() => {
												this.PopulateTable();
											}}
											id="FormSearchBtn"
											class=" btn btn-primary mr-1"
										>
											Search
										</button>
									</div>
								</div>

								{/* <div class="TableTop_Buttons">
                                    <span onClick={() => { $(".react-bs-table-csv-btn").click()}} class="TableExport_button"><i class="fa fa-download" aria-hidden="true"></i> Export</span>
                                </div> */}

								<Table
									keyField="id"
									data={this.state.data}
									page={this.state.page}
									sizePerPage={this.state.sizePerPage}
									exportPdf={this.ExportPdf}
									totalSize={this.state.TotalRecord}
									onTableChange={this.handleTableChange}
									changeSizePerPage={(size) => {
										setTimeout(() => {
											this.setState({
												exportLoading: true,
											});
											this.ExportData(size);
										}, 1000);
									}}
									exportLoading={this.state.ExportLoading}
									exportAllowed={this.state.permissions.includes("hcfs-export")}
									isPagination={true}
									pdfExportLoading={this.state.loadingExport}
									columns={columns}
									loading={this.state.loading}
									RefreshTable={this.PopulateTable}
									csvFileName={this.generateCSVFileName()}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	componentWillMount() {
		if (this.props.UserAuthentication.AuthToken === "") {
			this.props.history.push("/Login");
		}
	}

	componentDidMount() {
		Common.AddClassToMenueLink("MenuLink_HCFs");
		this.GetPageConfigData(() => {
			this.PopulateTable();
		});
		$(".Search_InputField").on("keypress", (e) => {
			if (e.which === 13) {
				this.PopulateTable();
			}
		});
		$("#SearchHcfId").on("keypress", (e) => {
			if (e.which === 13) {
				this.PopulateTable();
			}
		});

		this.SelectSubReciepents();
		// this.SelectFacilityTypes()

		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.APILinks.SelectAll_RolesPermissions,
			{
				pageSize: 15,
				pageNumber: 1,
			},
			(resp) => {
				const modifiedPermissions = resp.data
					.filter((p) => p.permissioN_GROUP === "HCFs" && p.permissioN_ALLOWED)
					.map((d) => d.permissioN_NAME);
				this.setState({ permissions: modifiedPermissions });
			}
		);
	}

	GetPageConfigData = (CallBack) => {
		this.props.ShowLoader({ Isloading: true });
		var d1 = $.Deferred();
		var d2 = $.Deferred();
		var d3 = $.Deferred();
		this.SelectProvinces(() => {
			d1.resolve();
		});
		this.SelectDistricts(() => {
			d2.resolve();
		});
		this.SelectTehsil(() => {
			d3.resolve();
		});
		$.when(d1, d2, d3).done(() => {
			this.props.ShowLoader({ Isloading: false });
			CallBack();
		});
	};
	// SelectFacilityTypes = () => {
	//     Common.Ajax(this.props.UserAuthentication.AuthToken, 'GET', false, Common.BaseUrlAPI+"/api/HCF/SelectFacilityType", {}, (data) => {
	//         this.setState({
	//             HCFTypelist: data.data
	//         })
	//     }, (error) => {
	//         this.props.ShowAlert({Type: 0, Msg: error})
	//         setTimeout(function () {
	//             $("#Alertmsgbtn").click()
	//         }, 50);
	//     })
	// }
	SelectProvinces = (Callback) => {
		this.setState({ ProvinceLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_Province,
			{},
			(data) => {
				this.setState({
					ProvinceLoader: false,
					Provincelist: data.data.sort(Common.compare),
				});
				Callback();
			},
			(error) => {
				this.setState({ ProvinceLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				Callback();
			}
		);
	};
	SelectDistricts = (Callback) => {
		this.setState({ DistrictLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_District,
			{},
			(data) => {
				this.setState({
					DistrictLoader: false,
					Districtlist: [
						...data.data,
						{ id: 1000001, name: "testsssss", subrecipientid: 68 },
					],
				});
				Callback();
			},
			(error) => {
				this.setState({ DistrictLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				Callback();
			}
		);
	};
	SelectTehsil = (Callback) => {
		this.setState({ TehsilLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_Tehsil,
			{},
			(data) => {
				this.setState({
					TehsilLoader: false,
					Tehsillist: [
						...data?.data,
						{ id: 1222222222, districtId: 1000001, name: "ssssss" },
					],
				});
				Callback();
			},
			(error) => {
				this.setState({ TehsilLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				Callback();
			}
		);
	};
	handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
		if (type === "sort") {
			let tempFieldorderLabel = sortField + "sortOrder";
			let tempFieldorder =
				this.state[tempFieldorderLabel] === ""
					? sortOrder
					: this.state[tempFieldorderLabel] === "asc"
						? "desc"
						: "asc";
			this.setState(
				{
					sortField,
					[tempFieldorderLabel]: tempFieldorder,
				},
				() => {
					this.PopulateTable();
				}
			);
			return;
			// let result = this.state.data
			// // Handle column sort
			// if (sortOrder === 'asc') {
			//     result = result.sort((a, b) => {
			//     if (a[sortField] > b[sortField]) {
			//         return 1;
			//     } else if (b[sortField] > a[sortField]) {
			//         return -1;
			//     }
			//     return 0;
			//     });
			// } else {
			//     result = result.sort((a, b) => {
			//     if (a[sortField] > b[sortField]) {
			//         return -1;
			//     } else if (b[sortField] > a[sortField]) {
			//         return 1;
			//     }
			//     return 0;
			//     });
			// }
			// return
		}
		this.setState(
			{
				page,
				sizePerPage,
			},
			() => {
				this.PopulateTable();
			}
		);
	};
	ExportPdf = () => {
		const doc = new jsPDF();
		this.setState({ loadingExport: true });
		var provinceIdString =
			this.state.ProvinceId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",";
		var districtIdString =
			this.state.DistrictId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.DistrictId, "id") + ",";
		var tehsilIdString =
			this.state.TehsilId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.TehsilId, "id") + ",";

		// Get user's roleId and assigned districts
		const userRoleId = this.props.UserAuthentication?.UserInfo?.roleId;
		const userAssignedDistricts = this.props.UserAuthentication?.UserInfo?.srDistrictIds;

		const parameters = {
			provinceIdString,
			districtIdString,
			tehsilIdString,
			pageSize: this.state.TotalRecord,
			pageNumber: this.state.page,
			category: this.state.HCFTypeId ? this.state.category : "",
			name: $("#SearchName").val(),
			hcfId: this.state.hcfId,
			isPaginate: true,
			ismicroscope: this.state.is_Microscope ? 1 : null,
			subrecipientId: this.state.SrId,
			typeId: String(this.state.HCFTypeId).charAt(0),
			isActive: this.state.isActive,
			fromDate:
				this.state.startDate == null || this.state.startDate === ""
					? null
					: Common.ConvertToUtcDateTime(
						Common.getOnlyDate(this.state.startDate) + " 00:00:00"
					),
			toDate:
				this.state.endDate == null || this.state.endDate === ""
					? null
					: Common.ConvertToUtcDateTime(
						Common.getOnlyDate(this.state.endDate) + " 23:59:59"
					),
		};

		// If user has roleId 8 or 14, handle their district restrictions
		if (userRoleId === 8 || userRoleId === 14) {
			// For SR Admin, filter by assigned districts only
			// The provinces will be derived from the districts automatically

			// If district filter is selected, use intersection of selected districts and assigned districts
			if (this.state.DistrictId.length > 0) {
				const selectedDistricts = this.state.DistrictId.map(d => d.id.toString());
				const assignedDistricts = userAssignedDistricts.split(',').filter(id => id !== '');
				const allowedDistricts = selectedDistricts.filter(id => assignedDistricts.includes(id));

				if (allowedDistricts.length > 0) {
					parameters.districtIdString = "," + allowedDistricts.join(',') + ",";
				} else {
					// If no intersection, use all assigned districts
					parameters.districtIdString = userAssignedDistricts;
				}
			} else {
				// If no district filter selected, use all assigned districts
				parameters.districtIdString = userAssignedDistricts;
			}

			// Clear province filter for SR Admin - let it be derived from assigned districts
			parameters.provinceIdString = "";
		}
		Common.Ajax(
			this.props.UserAuthentication?.AuthToken,
			"GET",
			false,
			Common.APILinks.GetAll_HCF,
			parameters,
			(data) => {
				$("#FormSearchBtn").prop("disabled", false);
				if (data.data.length > 0) {
					// Map
					var ProcessedProvince = Common.ProcessDataInArray(
						this.state.Provincelist,
						"id"
					);
					var ProcessedDistrict = Common.ProcessDataInArray(
						this.state.Districtlist,
						"id"
					);
					var ProcessedTehsil = Common.ProcessDataInArray(
						this.state.Tehsillist,
						"id"
					);
					for (var i in data.data) {
						data.data[i].provinceName =
							ProcessedProvince[data.data[i].provinceId]?.name;
						data.data[i].districtName =
							ProcessedDistrict[data.data[i].districtId]?.name;
						data.data[i].tehsilName =
							ProcessedTehsil[data.data[i].tehsilId]?.name;
					}
					doc.autoTable({
						theme: "grid",
						body: [...data.data],
						columns: [
							{ header: "id", dataKey: "id" },
							{ header: "Name", dataKey: "name" },
							{ header: "Address", dataKey: "address" },
							{ header: "Contact", dataKey: "contact" },
							{ header: "Type", dataKey: "typeId" },
							{ header: "Category", dataKey: "category" },
							{ header: "Active/Inactive", dataKey: "isActive" },
							{ header: "SR Name", dataKey: "subRecipient_ShortName" },
							{ header: "Province", dataKey: "provinceName" },
							{ header: "Tehsil", dataKey: "tehsilName" },
							{ header: "District", dataKey: "districtName" },
						],
					});
					this.setState({ loadingExport: false });

					doc.save("hcf.pdf");
				}
			},
			(error) => {
				$("#FormSearchBtn").prop("disabled", false);
				this.setState({ loading: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};
	ExportData = (size) => {
		$("#FormSearchBtn").prop("disabled", true);
		this.setState({ ExportLoading: true, loading: true });
		var provinceIdString =
			this.state.ProvinceId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",";
		var districtIdString =
			this.state.DistrictId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.DistrictId, "id") + ",";
		var tehsilIdString =
			this.state.TehsilId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.TehsilId, "id") + ",";

		// Get user's roleId and assigned districts
		const userRoleId = this.props.UserAuthentication?.UserInfo?.roleId;
		const userAssignedDistricts = this.props.UserAuthentication?.UserInfo?.srDistrictIds;

		const parameters = {
			provinceIdString,
			districtIdString,
			tehsilIdString,
			pageSize: this.state.TotalRecord,
			pageNumber: this.state.page,
			category: this.state.HCFTypeId ? this.state.category : "",
			name: $("#SearchName").val(),
			hcfId: this.state.hcfId,
			isPaginate: true,
			ismicroscope: this.state.isMicroscope,
			subrecipientId: this.state.SrId,
			typeId: String(this.state.HCFTypeId).charAt(0),
			isActive: this.state.isActive,
		};

		// If user has roleId 8 or 14, handle their district restrictions
		if (userRoleId === 8 || userRoleId === 14) {
			// For SR Admin, filter by assigned districts only (not by addressProvinceId which is personal address)
			// The provinces will be derived from the districts automatically

			// If district filter is selected, use intersection of selected districts and assigned districts
			if (this.state.DistrictId.length > 0) {
				const selectedDistricts = this.state.DistrictId.map(d => d.id.toString());
				const assignedDistricts = userAssignedDistricts.split(',').filter(id => id !== '');
				const allowedDistricts = selectedDistricts.filter(id => assignedDistricts.includes(id));

				if (allowedDistricts.length > 0) {
					parameters.districtIdString = "," + allowedDistricts.join(',') + ",";
				} else {
					// If no intersection, use all assigned districts
					parameters.districtIdString = userAssignedDistricts;
				}
			} else {
				// If no district filter selected, use all assigned districts
				parameters.districtIdString = userAssignedDistricts;
			}

			// Clear province filter for SR Admin - let it be derived from assigned districts
			parameters.provinceIdString = "";
		}

		Common.Ajax(
			this.props.UserAuthentication?.AuthToken,
			"GET",
			false,
			Common.APILinks.GetAll_HCF,
			parameters,
			(resp) => {
				$("#FormSearchBtn").prop("disabled", false);
				if (resp.data.length > 0) {
					// Map
					var ProcessedProvince = Common.ProcessDataInArray(
						this.state.Provincelist,
						"id"
					);
					var ProcessedDistrict = Common.ProcessDataInArray(
						this.state.Districtlist,
						"id"
					);
					var ProcessedTehsil = Common.ProcessDataInArray(
						this.state.Tehsillist,
						"id"
					);

					let processedData = resp.data.map(item => ({
						...item,
						provinceName: ProcessedProvince[item.provinceId]?.name || "",
						districtName: ProcessedDistrict[item.districtId]?.name || "",
						tehsilName: ProcessedTehsil[item.tehsilId]?.name || "",
						subRecipient_ShortName: item.subRecipient_ShortName || ""
					}));

					// Filter data for SR Admin users if needed
					if ((userRoleId === 8 || userRoleId === 14) && processedData.length > 0) {
						const assignedDistricts = userAssignedDistricts.split(',').filter(id => id !== '');
						processedData = processedData.filter(hcf =>
							assignedDistricts.includes(hcf.districtId?.toString())
						);
					}

					// Sort
					if (this.state[this.state.sortField + "sortOrder"] === "asc") {
						processedData = processedData.sort((a, b) => {
							if (a[this.state.sortField] > b[this.state.sortField]) {
								return 1;
							} else if (b[this.state.sortField] > a[this.state.sortField]) {
								return -1;
							}
							return 0;
						});
					} else {
						processedData = processedData.sort((a, b) => {
							if (a[this.state.sortField] > b[this.state.sortField]) {
								return -1;
							} else if (b[this.state.sortField] > a[this.state.sortField]) {
								return 1;
							}
							return 0;
						});
					}

					this.setState({
						data: processedData,
						TotalRecord: resp.totalRecord,
						exportLoading: false,
						ExportLoading: false,
					});

					$(".react-bs-table-csv-btn").click();
					setTimeout(() => {
						this.PopulateTable();
					}, 500);
				}
			},
			(error) => {
				$("#FormSearchBtn").prop("disabled", false);
				this.setState({ loading: false, ExportLoading: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};
	SelectSubReciepents = () => {
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectALl_SubRecipient,
			{},
			(resp) => {
				if (resp.status) {
					this.setState({
						SrList: resp.data.map((d) => ({
							id: d.id,
							name: d.short_name,
							districtId: d.districtid,
							...d,
						})),
					});
				}
			}
		);
	};

	importHCF_file = (e) => {
		$("#importHcfBtn").prop("disabled", true);

		const files = e.target.files;
		const formData = new FormData();
		formData.append("files", files[0]);

		Common.Ajax(
			this.props.UserAuthentication?.AuthToken,
			"POST",
			true,
			Common.APILinks.UploadHCFFile,
			formData,
			(resp) => {
				if (resp === "Success") {
					$("#importHcfBtn").prop("disabled", false);
					document.getElementById("importHcfBtn").value = null;
					this.props.ShowAlert({ Type: 1, Msg: "File Uploaded Successfully." });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
					this.setState({ data: [] });
					this.PopulateTable();
				} else {
					$("#importHcfBtn").prop("disabled", false);
					this.props.ShowAlert({
						Type: 0,
						Msg: "Something went wrong, please try again.",
					});
					setTimeout(function () {
						$("#Alertmsgbtn").click();
						document.getElementById("importHcfBtn").value = null;
					}, 50);
				}
			},
			(error) => {
				$("#importHcfBtn").prop("disabled", false);
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
					document.getElementById("importHcfBtn").value = null;
				}, 50);
			}
		);
	};

	PopulateTable = () => {
		$("#FormSearchBtn").prop("disabled", true);
		this.setState({ loading: true });
		var provinceIdString =
			this.state.ProvinceId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",";
		var districtIdString =
			this.state.DistrictId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.DistrictId, "id") + ",";
		var tehsilIdString =
			this.state.TehsilId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.TehsilId, "id") + ",";

		// Get user's roleId and assigned districts
		const userRoleId = this.props.UserAuthentication?.UserInfo?.roleId;
		const userAssignedDistricts = this.props.UserAuthentication?.UserInfo?.srDistrictIds;

		const parameters = {
			provinceIdString,
			districtIdString,
			tehsilIdString,
			pageSize: this.state.sizePerPage,
			pageNumber: this.state.page,
			category: this.state.HCFTypeId ? this.state.category : "",
			name: $("#SearchName").val(),
			hcfId: this.state.hcfId,
			isPaginate: true,
			ismicroscope: this.state.isMicroscope ? 1 : null,
			subrecipientId: this.state.SrId,
			typeId: String(this.state.HCFTypeId).charAt(0),
			isActive: this.state.isActive,
		};

		// If user has roleId 8 or 14, handle their district restrictions
		if (userRoleId === 8 || userRoleId === 14) {
			// For SR Admin, filter by assigned districts only (not by addressProvinceId which is personal address)
			// The provinces will be derived from the districts automatically

			// If district filter is selected, use intersection of selected districts and assigned districts
			if (this.state.DistrictId.length > 0) {
				const selectedDistricts = this.state.DistrictId.map(d => d.id.toString());
				const assignedDistricts = userAssignedDistricts.split(',').filter(id => id !== '');
				const allowedDistricts = selectedDistricts.filter(id => assignedDistricts.includes(id));

				if (allowedDistricts.length > 0) {
					parameters.districtIdString = "," + allowedDistricts.join(',') + ",";
				} else {
					// If no intersection, use all assigned districts
					parameters.districtIdString = userAssignedDistricts;
				}
			} else {
				// If no district filter selected, use all assigned districts
				parameters.districtIdString = userAssignedDistricts;
			}

			// Clear province filter for SR Admin - let it be derived from assigned districts
			parameters.provinceIdString = "";
		}

		Common.Ajax(
			this.props.UserAuthentication?.AuthToken,
			"GET",
			false,
			Common.APILinks.GetAll_HCF,
			parameters,
			(resp) => {
				$("#FormSearchBtn").prop("disabled", false);
				let { data } = resp;
				if (data?.length > 0) {
					// Map
					var ProcessedProvince = Common.ProcessDataInArray(
						this.state.Provincelist,
						"id"
					);
					var ProcessedDistrict = Common.ProcessDataInArray(
						this.state.Districtlist,
						"id"
					);
					var ProcessedTehsil = Common.ProcessDataInArray(
						this.state.Tehsillist,
						"id"
					);
					for (var i in data) {
						data[i].provinceName = ProcessedProvince[data[i].provinceId]?.name;
						data[i].districtName = ProcessedDistrict[data[i].districtId]?.name;
						data[i].tehsilName = ProcessedTehsil[data[i].tehsilId]?.name;
					}

					// Filter data for SR Admin users if needed
					if ((userRoleId === 8 || userRoleId === 14) && data.length > 0) {
						const assignedDistricts = userAssignedDistricts.split(',').filter(id => id !== '');
						data = data.filter(hcf =>
							assignedDistricts.includes(hcf.districtId?.toString())
						);
					}

					// Sort
					if (this.state[this.state.sortField + "sortOrder"] === "asc") {
						data = data.sort((a, b) => {
							if (a[this.state.sortField] > b[this.state.sortField]) {
								return 1;
							} else if (b[this.state.sortField] > a[this.state.sortField]) {
								return -1;
							}
							return 0;
						});
					} else {
						data = data.sort((a, b) => {
							if (a[this.state.sortField] > b[this.state.sortField]) {
								return -1;
							} else if (b[this.state.sortField] > a[this.state.sortField]) {
								return 1;
							}
							return 0;
						});
					}
				}

				this.setState({
					data,
					TotalRecord: resp.totalRecord,
					loading: false,
				});
			},
			(error) => {
				$("#FormSearchBtn").prop("disabled", false);
				this.setState({ loading: false });
			}
		);
	};
	onDelete = (id) => {
		this.setState(
			{
				alertModalData: {
					title: "Delete HCF",
					message: "Are you sure you want to delete this record.",
					First_Callback: () => {
						$("#Generic-modal-CloseBtn").click();
						this.DeleteRecord(id);
					},
					Second_Callback: () => {
						$("#Generic-modal-CloseBtn").click();
					},
					type: 1,
				},
			},
			() => {
				$("#Show_ArletModal").click();
			}
		);
	};
	DeleteRecord = (id) => {
		this.props.ShowLoader({ Isloading: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.APILinks.Delete_HCF,
			{ id: id },
			(Result) => {
				if (Result.status === true) {
					SyncConfig(
						() => {
							this.PopulateTable();
							this.props.ShowLoader({ Isloading: false });
							this.props.ShowAlert({ Type: 1, Msg: "Deleted Successfully." });
							setTimeout(function () {
								$("#Alertmsgbtn").click();
							}, 50);
						},
						() => {
							this.props.ShowLoader({ Isloading: false });
							this.props.ShowAlert({
								Type: 0,
								Msg: "Error in sync, please reload the page",
							});
							setTimeout(function () {
								$("#Alertmsgbtn").click();
							}, 50);
						}
					);
				} else {
					this.props.ShowLoader({ Isloading: false });
					this.props.ShowAlert({ Type: 0, Msg: Result.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
			},
			(error) => {
				this.props.ShowLoader({ Isloading: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wronge, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(HCF_List);
